import { render, staticRenderFns } from "./cateredProductList.vue?vue&type=template&id=70f64067&scoped=true&"
import script from "./cateredProductList.vue?vue&type=script&lang=js&"
export * from "./cateredProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f64067",
  null
  
)

export default component.exports